import styled from 'styled-components';
import { Card } from 'semantic-ui-react';
import { colors, text, verticalGutter, breakpoints } from '../../styles';

export default styled(Card)`
  position: relative;
  display: flex !important;
  height: 100%;

  .ui.divider {
    margin: 0;
  }

  .content {
    display: flex;
    flex-direction: column;

    @media only screen and (min-width: ${breakpoints.largeMonitor}) {
      padding: ${verticalGutter * 0.75}rem !important;
    }
  }

  .ui.message {
    font-weight: normal;

    h4,
    h5 {
      text-transform: uppercase;
    }
  }

  /* namespaced styles */
  .productcard {
    &__image {
      position: relative;
      margin: 0;
      height: 0;
      padding-bottom: ${(2 / 3) * 100}%;
      overflow: hidden;
      background: ${colors.greyBackground};

      .ui.image,
      &--placeholder {
        position: absolute;
        width: 100%;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        text-align: center;
      }

      .ui.image {
        height: 100%;
      }

      &--placeholder {
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        text-align: center;

        .isvg {
          display: inline-block;
          vertical-align: middle;
        }

        strong {
          margin: 0 0.25em;
          font: bolder italic ${text.big} ${text.fontNameHeader};
          text-transform: uppercase;
          color: #000;
        }
      }
    }

    &__name {
      margin: 0;
      // allow upto two lines
      min-height: 4em;
      text-transform: uppercase;
    }

    &__header {
      &,
      &.ui.header {
        padding: 0 0.5rem;
        text-transform: uppercase;
      }
    }

    &__footer {
      padding: 1em;
    }

    &__description {
      margin-bottom: ${verticalGutter / 2}rem;
      font-size: ${text.medium};
      font-weight: normal;
      color: ${colors.darkGrey};
      &-title {
        &,
        &:last-child {
          margin-bottom: 0.5rem;
          font-size: ${text.medium};
          text-transform: uppercase;
        }
      }
      ul,
      ol {
        margin: 0.5rem 0;
        padding-left: 1rem;
      }
    }

    &__badge {
      padding: ${verticalGutter / 1.5}rem 0.75rem !important;
      text-transform: uppercase;
      width: 100%;
      font-size: ${text.large} !important;
      text-align: center;

      /* we could overwrite from sematic */
      &.ui.inverted.yellow.segment {
        color: #000 !important;
        font-style: italic;
        font-family: ${text.fontNameHeader};
        word-break: break-word;
      }

      &--hang {
        margin: 0 !important;
        padding: 0.5rem 0.75rem 0.5rem !important;
        position: absolute !important;
        top: -1.5rem;
        right: -1rem;
        max-width: calc(100% - 1rem);
        width: auto;
        font-size: ${text.small} !important;
        text-align: left;
        letter-spacing: 0;
      }
    }

    &__link {
      display: block;
      padding: 0.5rem 0;
      text-align: center;
    }

    /* multiple link wrapper */
    &__links {
      display: inline-flex;
      flex-direction: column;
      padding: 0;
      margin: ${verticalGutter * 0.25}rem 0;
      list-style: none;

      .productcard__link {
        text-align: left;
        padding: 0.75rem 0;
        i.icon {
          float: left;
          height: auto;
        }
      }

      &:empty {
        display: none;
        border-bottom: none;
      }
    }

    /* align with bg--secondary box padding */
    &__cta {
      padding: 0 ${verticalGutter * 0.5}rem ${verticalGutter * 0.75}rem;
    }

    &__rte {
      margin: ${verticalGutter / 2}rem 0;
      @media only screen and (min-width: ${breakpoints.largeMonitor}) {
        margin: ${verticalGutter * 0.75}rem 0;
      }
      &,
      * {
        font-weight: normal;
        font-size: ${text.medium} !important;
        font-family: ${text.fontName}, Arial, sans-serif !important;
        line-height: ${text.lineHeight};
        color: ${colors.textColor} !important;
        word-break: break-word;
      }

      b,
      strong,
      h2,
      h3,
      h4,
      h5,
      h6,
      [style^='font-weight: bold'],
      [style^='font-weight: 700'],
      [style^='font-weight: 600'] {
        font-weight: bold !important;
      }

      p,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin-bottom: ${verticalGutter / 8}rem !important;
      }

      ul,
      ol {
        padding-left: ${verticalGutter / 2}rem;
        margin: ${verticalGutter / 4}rem 0 ${verticalGutter / 2}rem;
        li {
          margin-bottom: ${verticalGutter / 4}rem;
        }
      }
    }

    &.productcard {
      /* bundle product card (not the bundle card) */
      &--secondary {
        &.ui.card {
          height: auto;
          background: ${colors.greyBackground};
          box-shadow: none;
          &,
          &:last-child {
            /* to align with slider cards (has 0.5rem padding for shadow) */
            margin-top: -0.5rem;
          }

          .meta {
            color: ${colors.darkGrey};
          }
        }

        .productcard__name {
          min-height: 0;
        }
      }

      &--focus {
        [data-focus] {
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            height: 100%;
            background: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
  }
`;
